export default __webpack_public_path__ + "static/persimmon-tree-pendant-gold-db445d9503e012f45ef5687c5bd41698.png";